import React from "react";
import alenzaLogo from "assets/images/alenza/avlino-icon.svg";
import aiconLogo from "assets/images/aicon/portsight.png";
import styles from "./Auth.module.scss";

export const ThemeLogo = ({ theme }: { theme: string | undefined }) => {
  return (
    <div className={styles['logo-container']}>
      {theme ? (
        <img
          src={theme === "portsight" ? aiconLogo : alenzaLogo}
          alt="Logo"
          className={theme === "portsight" ? 'w-50' : styles['aicon_logo']}
        />
      ) : null}
      {theme !== 'portsight' && 
        <div className={styles['avlino-text']}>AVLINO</div>
      }
    </div>
  );
};
